import NiceModal from '@ebay/nice-modal-react';
import Modal from './modal';  

const pointsTips = (validMonths: number) => {
  NiceModal.show(Modal, { validMonths });
}

export const hidePointsTips  = () => {
  NiceModal.hide(Modal);  
}

export default pointsTips;